import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rcp-option-list',
  template: `<ng-content></ng-content>`,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--item-spacing-between-md);
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class OptionListComponent {}
